import React from 'react';
export const HomeImprovement = () => (
  <svg width="201px" height="159px" viewBox="0 0 201 159" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-509.000000, -1224.000000)">
        <g transform="translate(509.000000, 1224.000000)">
          <path
            d="M148.569827,153.828286 L52.4303682,153.828286 L0.508570047,101.847549 C-0.169523349,101.168692 -0.169523349,100.057914 0.508570047,99.3790569 L99.2670336,0.508488428 C99.9459986,-0.169496143 101.054655,-0.169496143 101.732749,0.508488428 L200.492084,99.3790569 C201.169305,100.057914 201.169305,101.168692 200.492084,101.847549 L148.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <path
            d="M142.8882,91.0141 L142.8882,92.9651"
            stroke="#8230DF"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M142.8882,96.8676 L142.8882,98.8186"
            stroke="#8230DF"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M146.7906,94.9164 L144.8396,94.9164"
            stroke="#8230DF"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M140.937,94.9164 L138.986,94.9164"
            stroke="#8230DF"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M157.1211,104.8666 C157.1211,105.6836 156.4581,106.3466 155.6401,106.3466 C154.8221,106.3466 154.1591,105.6836 154.1591,104.8666 C154.1591,104.0486 154.8221,103.3856 155.6401,103.3856 C156.4581,103.3856 157.1211,104.0486 157.1211,104.8666"
            fill="#CCD82B"
          />
          <path
            d="M119.023,80.0444 C119.023,80.8614 118.36,81.5244 117.542,81.5244 C116.724,81.5244 116.062,80.8614 116.062,80.0444 C116.062,79.2264 116.724,78.5644 117.542,78.5644 C118.36,78.5644 119.023,79.2264 119.023,80.0444"
            fill="#ED0722"
          />
          <path
            d="M107.9966,87.5629 L107.9966,89.3129"
            stroke="#CCD72A"
            strokeLinecap="round"
          />
          <path
            d="M107.9966,92.8129 L107.9966,94.5629"
            stroke="#CCD72A"
            strokeLinecap="round"
          />
          <path
            d="M111.4966,91.0629 L109.7466,91.0629"
            stroke="#CCD72A"
            strokeLinecap="round"
          />
          <path
            d="M106.2466,91.0629 L104.4966,91.0629"
            stroke="#CCD72A"
            strokeLinecap="round"
          />
          <path
            d="M37.1446,152.5961 L22.0266,152.5961"
            stroke="#E91C26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M177.1309,153.1332 L160.3849,153.1332"
            stroke="#E91C26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(97.000000, 100.710000)">
            <path
              d="M0.4077,8.1439 C0.3827,6.4409 0.9287,4.7659 2.0097,3.3709 L3.5277,7.5009 C4.0737,8.9859 5.7227,9.7489 7.2087,9.2039 L9.1577,8.4869 C9.8537,8.2309 10.4477,7.6969 10.7697,6.9979 C11.0927,6.2999 11.1467,5.5169 10.8597,4.8059 L9.2877,0.4579 C12.1007,0.8729 14.4257,2.7569 15.3987,5.4029 C16.1997,7.5829 15.9617,10.0149 14.7557,12.0389 C13.9517,13.3619 13.7967,14.9459 14.3087,16.3379 L16.7817,23.0649"
              fill="#FFFFFF"
            />
            <path
              d="M0.4077,8.1439 C0.3827,6.4409 0.9287,4.7659 2.0097,3.3709 L3.5277,7.5009 C4.0737,8.9859 5.7227,9.7489 7.2087,9.2039 L9.1577,8.4869 C9.8537,8.2309 10.4477,7.6969 10.7697,6.9979 C11.0927,6.2999 11.1467,5.5169 10.8597,4.8059 L9.2877,0.4579 C12.1007,0.8729 14.4257,2.7569 15.3987,5.4029 C16.1997,7.5829 15.9617,10.0149 14.7557,12.0389 C13.9517,13.3619 13.7967,14.9459 14.3087,16.3379 L16.7817,23.0649"
              stroke="#0F3043"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(98.000000, 111.710000)">
            <path
              d="M8.5601,10.6918 L7.2471,7.1188 C6.7691,5.8198 5.7201,4.7558 4.3431,4.2358 C2.6471,3.5778 1.2201,2.3378 0.3591,0.7618"
              fill="#FFFFFF"
            />
            <path
              d="M8.5601,10.6918 L7.2471,7.1188 C6.7691,5.8198 5.7201,4.7558 4.3431,4.2358 C2.6471,3.5778 1.2201,2.3378 0.3591,0.7618"
              stroke="#0F3043"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M129.0332,123.6586 C129.0332,125.5776 127.4772,127.1346 125.5582,127.1346 C123.6382,127.1346 122.0822,125.5776 122.0822,123.6586 C122.0822,121.7396 123.6382,120.1826 125.5582,120.1826 C127.4772,120.1826 129.0332,121.7396 129.0332,123.6586"
            fill="#FFFFFF"
          />
          <path
            d="M129.0332,123.6586 C129.0332,125.5776 127.4772,127.1346 125.5582,127.1346 C123.6382,127.1346 122.0822,125.5776 122.0822,123.6586 C122.0822,121.7396 123.6382,120.1826 125.5582,120.1826 C127.4772,120.1826 129.0332,121.7396 129.0332,123.6586 Z"
            stroke="#CCD72A"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M132.7442,125.1938 L135.4052,124.8458 L135.4052,122.1818 L132.7342,121.8328 C132.5402,120.9938 132.2032,120.2088 131.7532,119.5038 L133.3772,117.3468 L131.5272,115.5078 L129.3662,117.1558 C128.6682,116.7238 127.8982,116.4018 127.0752,116.2148 L126.7452,113.5218 L124.0802,113.5218 L123.7302,116.2178 C122.8892,116.4098 122.1042,116.7418 121.3972,117.1858 L119.2462,115.5498 L117.4092,117.3998 L119.0582,119.5088 C118.6072,120.2158 118.2712,121.0038 118.0772,121.8438 L115.4212,122.1818 L115.4212,124.8458 L118.0652,125.1748 C118.2542,126.0168 118.5862,126.8038 119.0322,127.5128 L117.4492,129.6818 L119.2992,131.5178 L121.4402,129.9038 C122.1382,130.3378 122.9112,130.6608 123.7372,130.8468 L124.0802,133.5058 L126.7452,133.5058 L127.1002,130.8418 C127.9322,130.6518 128.7092,130.3228 129.4112,129.8818 L131.5802,131.4778 L133.4172,129.6288 L131.7912,127.4968 C132.2302,126.7978 132.5562,126.0228 132.7442,125.1938 Z"
            stroke="#CCD72A"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M92.5201,154.4838 C92.5201,156.7068 87.4111,158.5088 81.1091,158.5088 C74.8071,158.5088 69.6981,156.7068 69.6981,154.4838 C69.6981,152.2598 74.8071,150.4588 81.1091,150.4588 C87.4111,150.4588 92.5201,152.2598 92.5201,154.4838"
            fill="#D0D7D8"
          />
          <path
            d="M150.6192,153.8129 C150.6192,156.0359 136.0442,157.8379 118.0662,157.8379 C100.0872,157.8379 85.5132,156.0359 85.5132,153.8129 C85.5132,151.5889 100.0872,149.7869 118.0662,149.7869 C136.0442,149.7869 150.6192,151.5889 150.6192,153.8129"
            fill="#D0D7D8"
          />
          <polygon
            fill="#FFFFFF"
            points="90.771 67.2777 53.811 63.5687 54.292 58.7737 91.252 62.4837"
          />
          <polygon
            stroke="#E3E7E9"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="90.771 67.2777 53.811 63.5687 54.292 58.7737 91.252 62.4837"
          />
          <polygon
            fill="#FFFFFF"
            points="88.2461 91.8529 51.2861 88.1429 51.7671 83.3489 88.7271 87.0579"
          />
          <polygon
            stroke="#E3E7E9"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="88.2461 91.8529 51.2861 88.1429 51.7671 83.3489 88.7271 87.0579"
          />
          <polygon
            fill="#FFFFFF"
            points="85.8374 116.4281 48.8774 112.7181 49.3584 107.9231 86.3184 111.6331"
          />
          <polygon
            stroke="#E3E7E9"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="85.8374 116.4281 48.8774 112.7181 49.3584 107.9231 86.3184 111.6331"
          />
          <polygon
            fill="#FFFFFF"
            points="81.36 151.766 150.619 151.766 150.619 123.514 81.36 123.514"
          />
          <polygon
            stroke="#73509E"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="81.36 151.766 150.619 151.766 150.619 123.514 81.36 123.514"
          />
          <path
            d="M94.4629,127.1527 L94.4629,149.0777 L94.4629,151.0577 C94.4629,153.5987 88.1219,155.6597 80.2989,155.6597 C72.4759,155.6597 66.1349,153.5987 66.1349,151.0577 L66.1349,149.0777 L66.1349,139.1677 L66.1349,133.6907 L66.1349,127.1527"
            fill="#FFFFFF"
          />
          <path
            d="M94.4629,127.1527 C94.4629,129.6937 88.1219,131.7547 80.2989,131.7547 C72.4759,131.7547 66.1349,129.6937 66.1349,127.1527 C66.1349,124.6107 72.4759,122.5507 80.2989,122.5507 C88.1219,122.5507 94.4629,124.6107 94.4629,127.1527"
            fill="#EB1322"
          />
          <polygon
            fill="#FFFFFF"
            points="84.3999 134.6401 80.3289 134.2321 89.5119 42.7441 93.5829 43.1541"
          />
          <polygon
            stroke="#DDE5E8"
            strokeLinecap="round"
            points="84.3999 134.6401 80.3289 134.2321 89.5119 42.7441 93.5829 43.1541"
          />
          <polygon
            fill="#FFFFFF"
            points="47.5225 151.5033 43.4515 151.0953 54.3265 42.7443 58.3975 43.1533"
          />
          <polygon
            stroke="#E3E7E9"
            points="47.5225 151.5033 43.4515 151.0953 54.3265 42.7443 58.3975 43.1533"
          />
          <g transform="translate(66.000000, 126.710000)">
            <path
              d="M28.4629,0.4427 L28.4629,22.3677 L28.4629,24.3477 C28.4629,26.8887 22.1219,28.9497 14.2989,28.9497 C6.4759,28.9497 0.1349,26.8887 0.1349,24.3477 L0.1349,22.3677 L0.1349,12.4577"
              fill="#FFFFFF"
            />
            <path
              d="M28.4629,0.4427 L28.4629,22.3677 L28.4629,24.3477 C28.4629,26.8887 22.1219,28.9497 14.2989,28.9497 C6.4759,28.9497 0.1349,26.8887 0.1349,24.3477 L0.1349,22.3677 L0.1349,12.4577"
              stroke="#73509E"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(66.000000, 126.710000)">
            <path d="M0.1348,6.9808 L0.1348,0.4428" fill="#FFFFFF" />
            <path
              d="M0.1348,6.9808 L0.1348,0.4428"
              stroke="#73509E"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M94.4629,127.1527 C94.4629,129.6937 88.1219,131.7547 80.2989,131.7547 C72.4759,131.7547 66.1349,129.6937 66.1349,127.1527 C66.1349,124.6107 72.4759,122.5507 80.2989,122.5507 C88.1219,122.5507 94.4629,124.6107 94.4629,127.1527"
            fill="#EB1322"
          />
          <path
            d="M94.4629,127.1527 C94.4629,129.6937 88.1219,131.7547 80.2989,131.7547 C72.4759,131.7547 66.1349,129.6937 66.1349,127.1527 C66.1349,124.6107 72.4759,122.5507 80.2989,122.5507 C88.1219,122.5507 94.4629,124.6107 94.4629,127.1527 Z"
            stroke="#73509E"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M71.5122,130.7602 C71.5122,130.7602 83.1062,145.0052 92.8582,142.5082 C102.6092,140.0112 94.4632,131.0882 94.4632,131.0882"
            stroke="#73509E"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(117.000000, 131.710000)">
            <path d="M0.542,0.7367 L30.954,0.7367" fill="#FFFFFF" />
            <path
              d="M0.542,0.7367 L30.954,0.7367"
              stroke="#E3E7E9"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(100.000000, 131.710000)">
            <path d="M0.878,0.7367 L12.477,0.7367" fill="#FFFFFF" />
            <path
              d="M0.878,0.7367 L12.477,0.7367"
              stroke="#E3E7E9"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M117.7788,108.0756 L146.0468,108.0756"
            stroke="#73509E"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.9903,108.4916 L92.5343,108.4916"
            stroke="#73509E"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(108.000000, 113.710000)">
            <path d="M0.1138,0.7064 L2.4458,7.8104" fill="#FFFFFF" />
            <path
              d="M0.1138,0.7064 L2.4458,7.8104"
              stroke="#E3E7E9"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M88.0459,104.933 L88.0459,122.551"
            stroke="#73509E"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M146.7803,104.7113 L146.7803,122.6483"
            stroke="#73509E"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
